import {Moment} from 'moment';
import {useState} from 'react';
import {useParams} from 'react-router-dom';
import {DateRangeInput} from '../../../../../../../components/date-range-input/date-range-input';
import {
  calcEndDateByRange,
  calcStartDateByRange,
  DateRangeType,
} from '../../../../../../../components/date-range-input/date-range-utils';
import {TinyHeader} from '../../../../../../../components/tiny-header/tiny-header';
import {EntityStatisticsDashboard} from '../../../../../../../components/entity-statistics-dashboard/entity-statistics-dashboard';
import {LocalStorageKey} from '../../../../../../../enums';

export default function EntityStatisticsSystemAdministratorOfficeScreen() {
  let {id}: {id?: string} = useParams();
  const [startDate, setStartDate] = useState(getInitialStartDate);
  const [endDate, setEndDate] = useState(getInitialEndDate);

  return (
    <>
      <TinyHeader
        middle={
          <DateRangeInput
            startDate={startDate}
            endDate={endDate}
            onChange={(startDate, endDate, range) => {
              setStartDate(startDate);
              setEndDate(endDate);
              if (range !== 'custom')
                localStorage.setItem(LocalStorageKey.EntityGeneralChartsRange, range);
            }}
          />
        }
      />
      <EntityStatisticsDashboard
        notShowRefreshButton
        entityId={id || ''}
        startDate={startDate}
        endDate={endDate}
      />
    </>
  );
}

// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------

function getInitialStartDate(): Moment {
  // Get stored range
  const storedRange = localStorage.getItem(
    LocalStorageKey.EntityGeneralChartsRange
  ) as DateRangeType | null;

  // Get start date by range
  return calcStartDateByRange(storedRange ?? '7d');
}

function getInitialEndDate(): Moment {
  // Get stored range
  const storedRange = localStorage.getItem(
    LocalStorageKey.EntityGeneralChartsRange
  ) as DateRangeType | null;

  // Get start date by range
  return calcEndDateByRange(storedRange ?? '7d');
}
